import React from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { FormattedMessage, injectIntl } from 'react-intl'
import BusinessActivity from 'components/BusinessActivity'
import FilterableList from 'components/FilterableList'
import { selectReviewsFilters } from 'store/business'
import messages from './messages'
import styles from './BusinessReviews.scss'

import { BusinessReviewPropType } from './props'

function BusinessReviews({
  intl,
  reviews = [],
  onScroll,
  onFilter,
  numberOfTotalItems = 0,
  numberOfDocumentedItems = 0,
  sources,
}) {
  const filters = useSelector(selectReviewsFilters)

  const dropdownOptions = sources.map(({ key, docCount }) => ({
    value: key,
    label: (
      <FormattedMessage
        {...messages.option}
        values={{
          label: key === 'angies' ? "Angie's List" : key,
          count: docCount,
        }}
        tagName='span'
      />
    ),
  }))

  const dropdownSelections = sources
    .filter(({ key }) => filters.includes(key))
    .map(({ key, docCount }) => ({
      value: key,
      label: (
        <FormattedMessage
          {...messages.option}
          values={{
            label: key,
            count: docCount,
          }}
          tagName='span'
        />
      ),
    }))

  return (
    <FilterableList
      type='review'
      items={reviews}
      filterKey='reviewSource'
      filterOptions={dropdownOptions}
      filterSelections={dropdownSelections}
      onFilter={onFilter}
      onScroll={onScroll}
      numberOfTotalItems={numberOfTotalItems || 0}
      numberOfDocumentedItems={numberOfDocumentedItems || 0}
      renderItem={review => (
        <div className={styles.review}>
          <BusinessActivity review={review} />
        </div>
      )}
    />
  )
}

BusinessReviews.propTypes = {
  intl: PropTypes.object.isRequired,
  reviews: PropTypes.arrayOf(BusinessReviewPropType),
  onScroll: PropTypes.func,
  onFilter: PropTypes.func,
  numberOfTotalItems: PropTypes.number,
  numberOfDocumentedItems: PropTypes.number,
}

export default injectIntl(BusinessReviews)
